import {
  Send, ShoppingCart, Gavel, FileText 
} from 'lucide-react';

export const TABS = [
  {
    id: 'requests',
    label: 'Purchase Requests',
    href: '/procurement/requests',
    icon: Send,
  },
  {
    id: 'sourcing',
    label: 'Sourcing Events',
    href: '/procurement/sourcing',
    icon: ShoppingCart,
  },
  {
    id: 'bids',
    label: 'Bids',
    href: '/procurement/bids',
    icon: Gavel,
  },
  {
    id: 'orders',
    label: 'Purchase Orders',
    href: '/procurement/orders',
    icon: FileText,
  },
] as const;

export type TabId = (typeof TABS)[number]['id'];
